<template>
	<div class="bg-default-dashboard">
		<div class=" py-lg-8 pt-lg-5">
			<b-container fluid style="width: 90%; position: relative;">
				<!-- <div class="header-body "  > -->
				<b-row class="mb-2">
					<b-col>
						<h1 class="text-white">QAQC - Punch List</h1>
					</b-col>
				</b-row>

				<b-row class="mt-4">
					<b-col>
						<div class="row">
							<dataset style="width: 100%" v-slot="{ ds }" :ds-data="obj_data_grid.data"
								:ds-sortby="['site', 'ref']"
								:ds-search-in="['site', 'ref', 'postal_code', 'company_name']">

								<div class="row" style="padding-bottom: 15px" :data-page-count="ds.dsPagecount">
									<!-- data grid - data per-page -->
									<div class="mt-2 col-sm-12 col-md-5 col-lg-5" style="
                      color: #ffffff;
                      font-family: Open Sans, sans-serif !important;
                      font-size: 0.875rem;
                    ">
										<dataset-show class="dataset-style" />
									</div>


									<!-- data grid - search-->
									<div class="mt-2 col-sm-12 col-md-5 col-lg-5">
										<dataset-search ds-search-placeholder="Search..." />
									</div>

									<!-- create new safety inspection entry -->
									<div class="mt-2 col-sm-12 col-md-2 col-lg-2 text-right" v-if="!oShare.is_epc">
									<!-- <div class="mt-2 col-sm-12 col-md-2 col-lg-2 text-right"> -->
										<base-button type="primary" @click="action_on_modal('show', 'modal-new-entry')">
											<i class="icon-plus-cs mr-1"></i> New Punch List
										</base-button>
									</div>

								</div>
								<div class="row">
									<div class="col-md-12">
										<div class="table-responsive">
											<table style="width: 100%" class="table table-striped d-md-table">
												<thead
													style="background-color: #3a656b; color: white; font-size: small; border-bottom: 20px solid #082A2F;">
													<tr>
														<th v-for="(th, index) in obj_data_grid.cols" :key="th.field"
															:class="['th-table-new', th.sort]">
															{{ th.name }}
															<i class="gg-select float-right"></i>
														</th>
													</tr>
												</thead>
												<dataset-item tag="tbody">
													<template #default="{ row, rowIndex }">
														<tr
															style="background-color: #23454A; color: white; font-size: smaller; border-bottom:  20px solid #082A2F;">
															<!-- <th scope="row">{{ rowIndex + 1 }}</th> -->
															<td class="tr-td-table-new" style="min-width: 150px">
																{{ row.ref }}
															</td>
															<td class="tr-td-table-new" style="min-width: 150px">
																{{ row.site }}
															</td>
															<td class="tr-td-table-new" style="min-width: 100px">
																{{ row.postal_code }}
															</td>
															<td class="tr-td-table-new" style="min-width: 150px">
																{{ row.contractor_company }}
															</td>
															<td class="tr-td-table-new" style="min-width: 85px">
																<div class="closure_item">
																	<div class="closure_item_pending">{{ row.punch_items_pending }}</div>
																	<div class="closure_item_approved">{{ row.punch_items_approved }}</div>
																	<div class="closure_item_rejected">{{ row.punch_items_rejected }}</div>
																</div>
															</td>
															<td class="tr-td-table-new" style="min-width: 130px">
																<span class="span_closure_by">Contractor: {{ row.contractor_name }}</span><br>
																<span class="span_closure_by">QA/QA: {{ row.qaqc_name }}</span><br>
																<span class="span_closure_by">O&M: {{ row.onm_name }}</span>
															</td>
															<td class="tr-td-table-new" style="min-width: 200px">
																<div style="margin-left: 40px">
																	<b-dropdown size="sm" split text="Action" right variant="dark" class="m-2">
																		<b-dropdown-item @click="handleDetails(rowIndex, row)">
																			<div class="icon-pencil-cs ml-1 mr-1"></div>
																			<span>Edit</span>
																		</b-dropdown-item>
																		<b-dropdown-item @click="download_qaqc_form(rowIndex, row)"
																			v-show="row.onm_acknowledge == '1'">
																			<div class="icon-document-cs ml-1 mr-1">
																			</div>
																			<span>Download PDF</span>
																		</b-dropdown-item>
																	</b-dropdown>
																</div>
															</td>
														</tr>
													</template>
												</dataset-item>
											</table>
										</div>
									</div>
								</div>
								<div class="d-flex flex-md-row flex-column justify-content-between align-items-center" style="
                    color: #ffffff;
                    font-family: Open Sans, sans-serif !important;
                    font-size: 0.875rem;
                  ">
									<dataset-info class="mb-2 mb-md-0" />
									<dataset-pager />
								</div>
							</dataset>
						</div>

					</b-col>
				</b-row>

				<!-- modal new entry -->
				<b-modal ref="modal-new-entry" size="xl" centered hide-footer hide-header title="">
					<div class="d-block">
						<!-- main - project information -->
						<b-row class="mb-3">
							<b-col class="mb-2" md="12" lg="12" xl="12"> <span class="text-white h3">New Punch List Entry</span></b-col>
						</b-row>
						<b-row class="mb-3">
							<b-col class="mb-2" md="12" lg="6" xl="6">
								<label for="" class="mb-1 text-white">Reference No</label>
								<b-form-input placeholder="Reference No" v-model="obj_ui.ref"></b-form-input>
							</b-col>
							<b-col class="mb-2" md="12" lg="6" xl="6">
								<label for="" class="mb-1 text-white">Contractor Company</label>
								<b-form-input placeholder="Contractor Company" v-model="obj_ui.contractor_company"></b-form-input>
							</b-col>
							<b-col class="mb-2" md="12" lg="6" xl="6">
								<label for="" class="mb-1 text-white">Site / Location</label>
								<base-input label="" v-show="obj_list.site_loading">
									<b-form-input placeholder="Please wait, loading project in progress" disabled></b-form-input>
								</base-input>
								<base-input label="" v-show="!obj_list.site_loading">
									<basic-select :options="obj_list.site_options" :selected-option="obj_list.site_item_selected"
										placeholder="Project Name" @select="getSelectedSiteInformation">
									</basic-select>

									<!-- <el-select v-model="selects.multiple" multiple filterable collapse-tags placeholder="Project Site"> -->
									<!-- 
									<el-select v-model="obj_list.site_selected" clearable collapse-tags value-key filterable remote
										:remote-method="getSiteByName" :loading="obj_list.site_loading" placeholder="Project Name"
										@change="getSelectedSiteInformation">
										<el-option v-for="option in obj_list.sites_all" :key="option.site_id" :label="option.site_name"
											:value="option.site_id"></el-option>
									</el-select> 
									-->
								</base-input>
							</b-col>
							<b-col class="mb-2" md="12" lg="6" xl="6">
								<label for="" class="mb-1 text-white">Postal Code</label>
								<b-form-input placeholder="Postal Code" v-model="obj_ui.postal_code"></b-form-input>
							</b-col>
						</b-row>
						<hr />

						<!-- buttons - cancel | draft | save -->
						<b-row>
							<b-col class="">
								<base-button type="danger" @click="action_on_modal('hide', 'modal-new-entry')">Cancel</base-button>
							</b-col>
							<b-col class="text-right">
								<base-button v-if="!obj_new_entry.submit_clicked" type="success"
									@click="submitData()">Submit</base-button>
								<base-button v-if="obj_new_entry.submit_clicked" type="success" disabled>Submit</base-button>
							</b-col>
						</b-row>
					</div>
				</b-modal>

				<!-- Modal loading / in progress -->
				<!--  body-classes="in-progress-modal-lg"  no-close-on-backdrop=false -->
				<modal :show.sync="isLoadingInProgress" ref="modal-loading" size="lg" modal-classes="in-progress-modal-lg"
					:no-close-on-backdrop="true" body-classes="p-0">
					<card type="secondary" header-classes="bg-transparent pb-5" body-classes="px-lg-5 py-lg-5"
						class="border-0 mb-0">
						<template>
							<div class="text-center text-muted mb-4">
								<h1 class="text-white"><b>Loading in progress</b></h1>
							</div>
							<div class="text-center">
								<div style="color: #ffffff;">
									<!-- <span class="fa fa-spinner fa-spin fa-3x"></span> -->
									<span class="icon-spinner-cs"></span>
								</div>
							</div>
						</template>
					</card>
				</modal>

			</b-container>
		</div>


	</div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate } from "@/assets/js/config.js";
import ErrorFunctionMixin from "@/assets/js/errorFunctionMix.js";
import CustomLibHelper from "@/assets/js/customLibHelper.js";
import axios from "axios";

import Dataset from '@/assets/js/customDataset.js';
import { DatasetItem, DatasetInfo, DatasetPager, DatasetSearch, DatasetShow } from "vue-dataset";
import { ToggleButton } from 'vue-js-toggle-button'
import { ModelSelect, BasicSelect, MultiSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

import jsonFormData from 'json-form-data';
// import {cloneDeep, pick } from 'lodash/cloneDeep';
// import cloneDeep from 'lodash/cloneDeep';
import { cloneDeep, pick } from 'lodash';


import Fuse from "fuse.js";



export default {
	mixins: [ErrorFunctionMixin, CustomLibHelper],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		Dataset,
		DatasetItem,
		DatasetInfo,
		DatasetPager,
		DatasetSearch,
		DatasetShow,
		ToggleButton,
		BasicSelect,
	},
	data() {
		return {
			oDev: {
				debug: true,
			},
			oShare: {
				user: null,
				is_epc: false,
				site_by_epc: [],
				status_tnc: 'DRAFT',
			},
			// myUserID: null,
			isLoadingInProgress: false,
			model_to_db: {
				site_id: null,
				site: '',
				postal_code: '',
				installation_address: '',
			},
			obj_ui: {
				site_id: '',
				site: '',
				postal_code: '',
				contractor_company: '',
				ref: '',
			},
			obj_new_entry: {
				submit_clicked: false,
				isSubmissionWarningVisible: false,
			},
			obj_list: {
				sites_all: [],
				site_info: [],
				site_loading: true,
				site_selected: null,
				site_options: [],
				site_item_selected: { value: '', text: '' },
			},
			tableData: [],
			obj_data_grid: {
				data: [],
				cols: [
					{
						name: "Reference No",
						field: "ref",
					},
					{
						name: "Site",
						field: "site",
					},
					{
						name: "Postal Code",
						field: "postal_code",
					},					
					{
						name: "Contractor",
						field: "contractor_company",
					},
					{
						name: "Punch Items",
						field: "",
					},					
					{
						name: "Closure By",
						field: "",
					},
					{},
				],
			},
			oField: {
				toggle_color: { checked: '#75C791', unchecked: '#Cf3140', disabled: '#CCCCCC' },
				toggle_pass: { checked: 'Pass', unchecked: 'Not Pass' },
			},
			filter_site: {
				// developers: [1, 2, 3],
				developers: [1, 2],
				project_name: null,
				project_ppa_sign_date_from_date: null,
				project_ppa_sign_date_to_date: null,
				project_ppa_capacity_greater_equal: null,
				project_ppa_capacity_lesser_equal: null,

				project_type: [1, 17],
				project_managers: [],
				project_engineers: [],
				project_business_development: [],
				project_safety: [],

				site_name: null,
				project_site_contractors: [],
				project_site_statuses: [],
				site_postal_code: null,
				site_code: null,
				roof_handover_date_from_date: null,
				roof_handover_date_to_date: null,
				site_cod_date_from_date: null,
				site_cod_date_to_date: null,
				site_target_turn_on_date_from_date: null,
				site_target_turn_on_date_to_date: null,
				site_actual_turn_on_date_from_date: null,
				site_actual_turn_on_date_to_date: null,
				site_total_capacity_greater_equal: null,
				site_total_capacity_lesser_equal: null,
				site_as_built_capacity_greater_equal: null,
				site_as_built_capacity_lesser_equal: null,
				site_module_brand_ids: [],
				site_module_quantity_greater_equal: null,
				site_module_quantity_lesser_equal: null,
				site_module_capacity_greater_equal: null,
				site_module_capacity_lesser_equal: null,
				site_module_allocation_total_capacity_greater_equal: null,
				site_module_allocation_total_capacity_lesser_equal: null,
				site_drawing_module_brand_ids: [],
				site_drawing_module_quantity_greater_equal: null,
				site_drawing_module_quantity_lesser_equal: null,
				site_drawing_module_capacity_greater_equal: null,
				site_drawing_module_capacity_lesser_equal: null,
				site_drawing_total_capacity_greater_equal: null,
				site_drawing_total_capacity_lesser_equal: null,
				site_drawing_ifa_date_from_date: null,
				site_drawing_ifa_date_to_date: null,
				site_drawing_ifc_date_from_date: null,
				site_drawing_ifc_date_to_date: null,
				ntp_applicable: null,
				ntp_issued: null,
				ntp_issue_date_from_date: null,
				ntp_issue_date_to_date: null,
				internal_project_handover_completed: null,
				internal_project_handover_date_from_date: null,
				internal_project_handover_date_to_date: null,
				kick_off_meeting_completed: null,
				kick_off_meeting_date_from_date: null,
				kick_off_meeting_date_to_date: null,
			},
		};
	},
	created() {
		const LoginUser = JSON.parse(window.localStorage.getItem("loginUser"));
		this.oShare.user = LoginUser;


		//_ dummy test user
		// this.oShare.user = {
		// 	email: "troyspd@outlook.com",
		// 	id: 405,
		// 	name: "Troy EPC",
		// 	role_id: 12
		// }

		this.getQAQCList();
	},
	mounted() {
		this.isLoadingInProgress = true;
	},
	computed: {

	},
	watch: {

	},	
	methods: {
		getQAQCList() {
			axios
				.get(apiDomain + 'e_forms/punchlist_form', { headers: getHeader() })
				.then(response => {
					if (response.status === 200) {
						this.devMsg(this.oDev.debug, 'getQAQCList', 'gs')
						this.devMsg(this.oDev.debug, response, 'ge')

						this.tableData = response.data.data;
						this.populateDSqaqc();
					}
				})
				.catch(error => {
					// console.log(error.response.status);
					console.log(error.response);
					this.errorFunction(error, "get QAQC list data");
				});
				// .finally(() => {
				// 	this.getSiteByName()
				// 	this.isLoadingInProgress = false;
				// });
		},

		//_ populate data grid
		populateDSqaqc() {
			//_ populate data grid
			//  why not just use this.tableData ? because the search not working if the data is nested, e.x project.project_name
			//	also we going to use for filter data based on the user, contractor only allow to see project that they assigned on

			this.devMsg(this.oDev.debug, 'populateDSqaqc', 'gs')

			if (this.oShare.user.role_id == '12') {
				this.devMsg(this.oDev.debug, 'is contractor')

				//_ contractor
				this.oShare.is_epc = true;

				axios
					.get(apiDomain + "project/project_site.show_by_contractor_short/" + this.oShare.user.id, { headers: getHeader() })
					.then((response) => {
						if (response.status === 200) {
							//_ get all projects for the active epc
							let arrEPCProjects = response.data.data;

							//_ instead of array object, let's simplified it into just the site code [1, 2, 3, etc] 
							this.oShare.site_by_epc = arrEPCProjects.map(item => item.site_id);

							this.obj_data_grid.data = this.tableData.reduce((res, item) => {
								if (this.oShare.site_by_epc.includes(item.site_id)) {
									let tmpClosure = this.get_punch_items_status(item.punchListItems);
									res.push({
										entry_id: item.id,
										site_id: item.site_id,
										site: item.site,
										ref: item.ref,
										contractor_company: item.contractor_company,
										postal_code: item.postal_code,
										contractor_name: item.contractor_name,
										qaqc_name: item.qaqc_name,
										onm_acknowledge: item.onm_acknowledge,
										onm_name: item.onm_name,
										punch_items_pending: tmpClosure.pending,
										punch_items_approved: tmpClosure.approved,
										punch_items_rejected: tmpClosure.rejected,
									});
								}
								return res;
							}, []);
						}
					})
					.catch((error) => {
						console.log(error.response.status);
					})
					.finally(() => {
						this.getSiteByName();
						this.isLoadingInProgress = false;
					})
			} else {
				this.devMsg(this.oDev.debug, 'is non contractor')
				//_ non contractor
				this.obj_data_grid.data = this.tableData.reduce((res, item) => {
					let tmpClosure = this.get_punch_items_status(item.punchListItems);
					res.push({
						entry_id: item.id,
						site_id: item.site_id,
						site: item.site,
						ref: item.ref,
						contractor_company: item.contractor_company,
						postal_code: item.postal_code,
						contractor_name: item.contractor_name,
						qaqc_name: item.qaqc_name,
						onm_acknowledge: item.onm_acknowledge,
						onm_name: item.onm_name,
						punch_items_pending: tmpClosure.pending,
						punch_items_approved: tmpClosure.approved,
						punch_items_rejected: tmpClosure.rejected,
					});
					return res;
				}, []);

				this.getSiteByName();
				this.isLoadingInProgress = false;
			}

			this.devMsg(this.oDev.debug, '', 'ge')
		},
		handleDetails(index, row) {
			// window.open("QAQC/" + row.id, "_blank");
			window.open("/QAQC/Punchlist/edit/" + row.entry_id, "_blank");
			// window.open("QaqcTccForm3", "_blank");
		},

		get_punch_items_status( arr_punch_items ) {
			console.log('get_punch_items_status -> arr_punch_items')
			console.log(arr_punch_items);

			let retval = {
				pending: 0,
				approved: 0,
				rejected: 0,
			}

			if ( arr_punch_items.length > 0 ) {
				let arrPending = arr_punch_items.filter(element => (element.status === 'PENDING' ));
				let arrApproved = arr_punch_items.filter(element => (element.status === 'APPROVED' ));
				let arrRejected = arr_punch_items.filter(element => (element.status === 'REJECTED' ));

				retval = {
					pending: arrPending.length,
					approved: arrApproved.length,
					rejected: arrRejected.length,
				}
			}

			return retval
		},

		getSiteByName(siteName = '') {
			//_ get site_id by site_name that type into the dropdown selection

			this.filter_site.site_code = null;
			this.filter_site.site_name = null;
			axios
				.post(apiDomain + "project/project_site.show_by_filter", this.filter_site, { headers: getHeader(), })
				.then(response => {
					if (response.status === 200) {
						this.devMsg(this.oDev.debug, 'getSiteByName', 'gs')
						this.devMsg(this.oDev.debug, response.data.data, 'ge')

						this.obj_list.sites_all = response.data.data;
						this.obj_list.sites_all.forEach((entry => {
							// if (this.oShare.site_by_epc.length > 0) {
							// 	// if ( this.obj_list.site_by_epc.includes(item.site_id) ) {
							// 	if (this.oShare.site_by_epc.includes(entry.site_id)) this.obj_list.site_options.push({ value: entry.site_id, text: entry.site_name })
							// } else {
							// 	this.obj_list.site_options.push({ value: entry.site_id, text: entry.site_name })
							// }							
							if ( this.oShare.is_epc ) {
								this.devMsg(this.oDev.debug, 'push additional special for epc')
								if (this.oShare.site_by_epc.includes(entry.site_id)) this.obj_list.site_options.push({ value: entry.site_id, text: entry.site_name })
							} else {
								this.obj_list.site_options.push({ value: entry.site_id, text: entry.site_name })
							}

						}))
					}
				})
				.catch(error => {
					this.errorFunction(error, "Search Project Site Listing")
				})
				.finally(() => {
					this.obj_list.site_loading = false;
				});

		},
		// getSelectedSiteInformation(site_id) {
		getSelectedSiteInformation(selectedItem) {
			this.obj_list.site_item_selected = { value: selectedItem.value, text: selectedItem.text }
			this.obj_list.site_selected = selectedItem.value

			let site_id = selectedItem.value;
			if (site_id != '') {
				axios
					.get(apiDomain + "project/project_site/" + site_id, { headers: getHeader(), })
					.then((response) => {
						if (response.status === 200) {
							this.devMsg(this.oDev.debug, 'getSelectedSiteInformation', 'gs')
							this.devMsg(this.oDev.debug, response, 'ge')

							// this.model_to_db.site_id = response.data.data[0].site_id;
							// this.model_to_db.site = response.data.data[0].project.site;
							// this.model_to_db.postal_code = response.data.data[0].site_postal_code;
							// this.model_to_db.installation_address = response.data.data[0].site_address;
							this.obj_ui.site_id = response.data.data[0].site_id;
							this.obj_ui.site = response.data.data[0].project.project_name;
							this.obj_ui.postal_code = response.data.data[0].site_postal_code;
							this.obj_ui.contractor_company = response.data.data[0].site_contractor.contractor.contractor_name;
						}
					})
					.catch((error) => {
						this.errorFunction(error, "Site Information");
					});
			} else {
				// this.model_to_db.postal_code = '';
				// this.model_to_db.installation_address = '';
				this.obj_ui.postal_code = '';
				this.obj_ui.contractor_company = '';
			}

		},
		checkForRequiredData() {
			this.devMsg(this.oDev.debug, 'checkForRequiredData', 'gs')
			
			this.devMsg(this.oDev.debug, 'this.obj_ui')
			this.devMsg(this.oDev.debug, this.obj_ui)

			var checker = false;
			if (
				!this.obj_ui.site_id ||
				!this.obj_ui.site ||
				!this.obj_ui.postal_code ||
				!this.obj_ui.contractor_company ||
				!this.obj_ui.ref
			) {
				if (this.obj_ui.site_id == '' || this.obj_ui.site == '') {
					this.redErrorNotify(
						"<b>Invalid Input : No project selected. </b>"
					);
				} else if (this.obj_ui.ref == '') {
					this.redErrorNotify(
						"<b>Invalid Input : Reference no is a Mandatory Field.</b>"
					);
				} else if (this.obj_ui.contractor_company == '') {
					this.redErrorNotify(
						"<b>Invalid Input : Contractor Company is a Mandatory Field.</b>"
					);
				} else if (this.obj_ui.postal_code == '') {
					this.redErrorNotify(
						"<b>Invalid Input : Postal Code is a Mandatory Field.</b>"
					);
				} else {
					this.redErrorNotify(
						"<b>Invalid Input : Please fill in all the Mandatory Fields.</b>"
					);
				}
			} else {
				checker = true;
			}

			if (checker) {
				this.devMsg(this.oDev.debug, 'passed all checks')

				this.obj_new_entry.submit_clicked = true;
				this.obj_new_entry.isSubmissionWarningVisible = true;
			}

			this.devMsg(this.oDev.debug, '', 'ge')

			return (checker);
		},
		submitData() {
			if (this.checkForRequiredData()) {

				this.devMsg(this.oDev.debug, 'submitData', 'gs')
				this.devMsg(this.oDev.debug, this.obj_ui, 'ge')

				axios
					.post(apiDomain + 'e_forms/create_punch_list', this.obj_ui, { headers: getHeader() })
					.then((response) => {
						if (response.status === 200) {
							this.$notify({
								message:
									'<b>QAQC Punch List New Entry Successfully Created and Submitted.</b>',
								timeout: 10000,
								icon: 'ni ni-bell-55',
								type: 'default',
							});

							// this.$router.back()
							// this.is_editing_inspection = false;
							this.action_on_modal('hide', 'modal-new-entry');
						}
					})
					.catch((error) => {
						if (error.response) {
							// Handle error with response
							this.errorFunction(error, "QAQC Punch List New Entry Submit");
						} else {
							// Handle error without response
							// console.log(error)
							this.$notify({
								message:
									// '<b>System Warning : </b> - The System is Currently Busy or Un-Available.',
									'<b>System Warning : </b> - There is an error with your submission. Please contact Sembcorp staff you know or email to sembsolar.momens@sembcorp.com',
								timeout: 15000,
								icon: 'ni ni-bulb-61',
								type: 'warning',
							});
						}
						// this.submit_clicked = false;
						// this.isSubmissionWarningVisible = false;
						// this.model_to_db.status = this.obj_inspection.previous_status;
					})
					.finally(() => {
						this.isLoadingInProgress = false;
						this.obj_new_entry.submit_clicked = false;
						this.obj_new_entry.isSubmissionWarningVisible = false;

						this.getQAQCList();
					});
			}
		},
		action_on_modal(what_action, what_modal, isReset = true) {
			// this.isLoadingInProgress = true;

			if (isReset) this.reset_entry();

			if (what_action == 'show') {
				this.$refs[what_modal].show()
			} else {
				this.$refs[what_modal].hide();
			};
		},
		reset_entry() {
			this.obj_list.site_item_selected = { value: '', text: '' }

			this.obj_ui = {
				site_id: '',
				site: '',
				postal_code: '',
				contractor_company: '',
				ref: '',
			};

			this.obj_list.site_selected = null;
		},




		download_qaqc_form(index, row) {
			let api_url = apiDomain + 'e_forms/export-pdf/' + row.entry_id;
			axios
				.get(api_url, { headers: getHeader(), responseType: 'blob' })
				.then((response) => {
					if (response.status === 200) {
						this.msg_notify_ok('<b>PV Successfully download QAQC form.</b>');

						window.open(URL.createObjectURL(response.data))
					}
				})
				.catch((error) => {
					if (error.response) {
						// Handle error with response
						this.errorFunction(error, "Download QAQC Form");
					} else {
						// Handle error without response
						this.msg_notify_sembcorp();
					}
				})
				.finally(() => {

				});
		},
	},
};
</script>

<style scoped>
/deep/ .dz-error {
	display: none;
}

/deep/ .el-popper .popper__arrow,
.el-popper .popper__arrow::after {
	border-style: hidden;
}

/deep/ .list-group-item {
	border: 1px solid #e9ecef00;
}

/deep/ select option {
	margin: 40px;
	background-color: #306b74 !important;
	color: #fff;
	text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
}

/deep/ select option:disabled {
	color: #fff;
}

/deep/ .btn {
	color: white;

	&:hover {
		&::placeholder {
			color: white;
		}
	}
}

/deep/ .btn-outline-danger {
	background-color: #f5365c;
}

/deep/ .card-header {
	background-color: #3d6971d9;
	padding: 20px 0 20px 0;

}
</style>

<style scoped>
/deep/ input::-webkit-input-placeholder {
	color: #fff;
}

/deep/ input::-moz-input-placeholder {
	color: #fff;
}

/deep/ input::-ms-input-placeholder {
	color: #fff;
}

/deep/ .el-input .el-input__inner {
	background-color: #2C545A;
	color: #fff;
	border: 0px;
	border-radius: 10px;
	padding-top: 3px;
	padding-bottom: 2px;

	/* &::placeholder {
    color: white;
  } */
}

/deep/ .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
	background-color: #23504e;
}

/deep/ .el-select-dropdown {
	background-color: #306b74;
	margin: 0px;
}

/deep/ .el-select-dropdown__item {
	color: white;
	background-color: #183034;

	::hover {
		background-color: #2C545A
	}

}

/deep/ .el-select {
	.el-input .el-input__inner {
		&::placeholder {
			color: white;
		}
	}

}

/deep/ .el-select__input {
	color: white;
	background-color: #2C545A;
}

/deep/ .el-select__input.hover,
.el-select__input:hover {
	background-color: #23504e;
}


/deep/ .nav-pills .nav-link {
	/* padding: 0.75rem 1rem; */
	color: #cdcfdb;
	font-weight: 500;
	font-size: 0.875rem;
	-webkit-box-shadow: 0 0px 0px rgba(50, 50, 93, 0.11), 0 0px 0px rgba(0, 0, 0, 0.08);
	box-shadow: 0 0px 0px rgba(50, 50, 93, 0.11), 0 0px 0px rgba(0, 0, 0, 0.08);
	background-color: #3d697100;
	-webkit-transition: all 0.15s ease;
	transition: all 0.15s ease;

	&:hover {
		color: white;
	}
}

/deep/ .nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
	color: #fff;
	background-color: #175f6be3;
	border-left: 3px solid #85BCCE;
	width: 100%;

}

/deep/ .nav-pills .nav-item:not(:last-child) {
	padding-right: 0rem;
}

/deep/ .grid-tr-new {
	background-color: #23454A;
	color: white;
	font-size: smaller;
	border-bottom: 20px solid #306b74;
}
</style>

<!-- Class For Modal -->
<style scoped>
/deep/ hr {
	background-color: white;
}

.th-table-new {
	padding-top: 35px;
	padding-bottom: 35px;
	padding-left: 20px;
	font-size: small;
	/*0.65rem;*/
}

/deep/ .tr-td-table-new {
	padding-top: 15px;
	padding-bottom: 15px;
	padding-left: 20px;
}

/deep/ .table td,
.table th {
	vertical-align: middle;
}

/* 
.th-table-new-mdl {
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 20px;
  font-size: small;
} */

.tr-td-table-new-mdl {
	padding-top: 10px;
	padding-bottom: 10px;
	padding-left: 20px;
}

/deep/ .form-control {
	background-color: #2C545A;
	border-color: #2C545A;
	color: white;

	&:focus {
		background-color: #2C545A;
		border-color: #2C545A;
		/* color: white; */
	}

	&::placeholder {
		color: rgb(163, 163, 163);
	}
}

/deep/ .form-control {
	&:focus {
		&::placeholder {
			color: rgb(163, 163, 163);
		}
	}
}

.input-group-text {
	background-color: #2C545A;
	;
	color: white;

	&:focus {
		background-color: #2C545A;
		;
		border-color: #1D4147;
		color: white;
	}
}

.focused {
	.input-group-text {
		background-color: #2C545A;
	}
}

.navbar-search-dark .input-group {
	background-color: #23454A;
	color: black;
	border-color: rgba(255, 255, 255, 0.6);
}

.navbar-search .input-group {
	border-radius: 7px;
}

select {
	background: url("data:image/svg+xml,<svg width='10' height='7' viewBox='0 0 10 7' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M5.02552 6.35057L0.320068 0.46875H9.73098L5.02552 6.35057Z' fill='white'/></svg>") no-repeat;
	background-position: calc(100% - 0.75rem) center !important;
	-moz-appearance: none !important;
	-webkit-appearance: none !important;
	appearance: none !important;
	padding-right: 2rem !important;
}

option {
	width: 100px !important;
}

/deep/ #__BVID__46___BV_modal_content_ {
	background-color: #306b74;
}

/deep/ .modal-content {
	background-color: #306b74 !important;
}

/deep/ .modal-body {
	background-color: #306b74 !important;
}

/deep/ .form-group {
	margin-bottom: 0 !important;
}
</style>

<!-- el-select custom -->
<style scoped>
/deep/ .el-select__input {
	opacity: 0;
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
	border-color: transparent !important;
}

/deep/ .el-select .el-input .el-input__inner:focus {
	border-color: transparent !important;
}

/deep/ .el-select .el-select__tags .el-tag {
	background-color: #183034;
}

/deep/ .el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
	background-color: #183034;
	color: #ffffff;
}

/deep/ .el-select-dropdown.el-popper .el-select-dropdown__item.selected,
.el-select-dropdown.el-popper.is-multiple .el-select-dropdown__item.selected {
	background-color: #183034;
	color: #ffffff;
}
</style>

<!-- dataset -->
<style scoped>
/deep/ div.dataset-style select {
	color: #ffffff;
	background-color: #2c545a;
	border-color: #2c545a;
}

/deep/ div.dataset-style select.form-control {
	color: #ffffff;
	background-color: #2c545a;
	border-color: #2c545a;
}

/deep/ div.dataset-style select>option {
	color: #ffffff;
	background-color: #2c545a;
	border-color: #2c545a;
}

/deep/ .closure_item {
	display: flex;
	justify-content: space-around;
	/* flex-direction: column; */
	/*
	flex-wrap: wrap;
	align-items: center;
	align-content: center; */
	border-top: 0px solid #e9ecef;
}
/deep/ .closure_item_pending {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background-color: #9f9f9f;
	justify-content: center;
	align-items: center;
	text-align: center;
	align-content: center;
	margin-bottom: 3px;
	/* flex-direction: row; */
}
/deep/ .closure_item_approved {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background-color: #35a17e;
	justify-content: center;
	align-items: center;
	text-align: center;
	align-content: center;	
	margin-bottom: 3px;
	/* 
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap; */
}
/deep/ .closure_item_rejected {
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background-color: #eb2c2c;
	justify-content: center;
	align-items: center;
	text-align: center;
	align-content: center;	
	/* 
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap; */
}

/deep/ .span_closure_by {
	display: inline-block;
  padding-bottom: 3px;
}
</style>

<!-- grid observation item -->
<style scoped>
/deep/ .grid-obs-item thead {
	background-color: rgb(82 146 155);
	color: white;
	font-size: small;
	border-bottom: 20px solid #306b74;
}

/deep/ .th-table-new-mdl {
	padding-top: 15px;
	padding-bottom: 15px;
	padding-left: 20px;
	font-size: small;
}

.list-group-item {
	background-color: #23454A;
	border-bottom: 1px solid black;
}
</style>

<!-- pagination style -->
<style scoped>
/deep/ .pagination {
	display: flex;
	padding-left: 0;
	list-style: none;
	border-radius: 0.25rem;
	color: black;
}

/deep/ .page-link {
	position: relative;
	display: block;
	padding: 0.5rem 0.65rem;
	margin-left: -1px;
	line-height: 1.25;
	color: #345f66;
	background-color: #fff;
	border: 1px solid #dee2e6;
}

/deep/ .page-link:hover {
	z-index: 2;
	color: #345f66;
	text-decoration: none;
	background-color: #e9ecef;
	border-color: #dee2e6;
}

/deep/ .page-link:focus {
	z-index: 3;
	outline: 0;
	box-shadow: 0 0 0 0.2rem rgba(62, 175, 124, 0.25);
}

/deep/ .page-item:first-child .page-link {
	margin-left: 0;
	border-top-left-radius: 0.25rem;
	border-bottom-left-radius: 0.25rem;
}

/deep/ .page-item:last-child .page-link {
	border-top-right-radius: 0.25rem;
	border-bottom-right-radius: 0.25rem;
}

/deep/ .page-item.active .page-link {
	z-index: 3;
	color: #fff;
	background-color: #345f66;
	border-color: #3a656b;
}

/deep/ .page-item.disabled .page-link {
	color: #6c757d;
	pointer-events: none;
	cursor: auto;
	background-color: #fff;
	border-color: #dee2e6;
}

/deep/ .pagination-lg .page-link {
	padding: 0.75rem 1.5rem;
	font-size: 1.25rem;
	line-height: 1.5;
}

/deep/ .pagination-lg .page-item:first-child .page-link {
	border-top-left-radius: 0.3rem;
	border-bottom-left-radius: 0.3rem;
	width: 60px;
}

/deep/ .pagination-lg .page-item:last-child .page-link {
	border-top-right-radius: 0.3rem;
	border-bottom-right-radius: 0.3rem;
}

/deep/ .pagination-sm .page-link {
	padding: 0.25rem 0.5rem;
	font-size: 0.875rem;
	line-height: 1.5;
}

/deep/ .pagination-sm .page-item:first-child .page-link {
	border-top-left-radius: 0.2rem;
	border-bottom-left-radius: 0.2rem;
}

/deep/ .pagination-sm .page-item:last-child .page-link {
	border-top-right-radius: 0.2rem;
	border-bottom-right-radius: 0.2rem;
}

/deep/ .b-pagination-pills .page-item .page-link {
	border-radius: 50rem !important;
	margin-left: 0.25rem;
	line-height: 1;
}

/deep/ .b-pagination-pills .page-item:first-child .page-link {
	margin-left: 0;
}
</style>

<!-- modal - loading in progress -->
<style scoped>
/deep/ .in-progress-modal-lg .modal-dialog {
	width: 100% !important;
	max-width: none !important;
	height: 100% !important;
	margin: 0 !important;
}

/deep/ .in-progress-modal-lg .modal-dialog .modal-content {
	height: 100% !important;
	border: 0 !important;
	border-radius: 0 !important;
	/* background-color: transparent !important; */
	background: rgba(0, 0, 0, 0.5);
	border: none !important;
}
</style>

<!-- dropdown action menu -->
<style scoped>
/deep/ .btn-dark,
.btn-dark:hover {
	color: #fff;
	background-color: #2c545a;
	border-color: #2c545a;
}

/deep/ .dropdown-menu {
	background-color: #23444a !important;
	border: 1px solid #ffffff;
}

/deep/ .dropdown-item {
	&:hover {
		background-color: #3a656b !important;
		color: #ffffff;
	}

	span {
		padding-left: 8px;
		vertical-align: super;
	}
}
</style>